import { ProductLabel, Link, theme } from '@notino/react-styleguide';

import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const ReviewMotivationProductLabel = styled(ProductLabel)`
  font-size: 0.75rem;
  text-transform: none;
  padding: 0.25rem 0.375rem;
`;

export const verifiedReviewLabelClass = css`
  color: ${theme.color.text.positive};
`;

export const TooltipContent = styled.div`
  max-width: max-content;
  width: 15rem;
  padding: 0.5rem;
`;

export const MoreInfoLink = styled(Link)`
  margin-left: 0.25rem;
  text-decoration: underline;
`;
